import { IApiQueryOptions } from 'api/ApiClient';

export enum Payments {
  GET_SITE_PAYMENTS_REQUEST = '@payment/GET_SITE_PAYMENTS_REQUEST',
  GET_SITE_PAYMENTS_SUCCESS = '@payment/GET_SITE_PAYMENTS_SUCCESS',
  GET_SITE_PAYMENTS_FAIL = '@payment/GET_SITE_PAYMENTS_FAIL',

  GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_REQUEST = '@payment/GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_REQUEST',
  GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_SUCCESS = '@payment/GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_SUCCESS',
  GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_FAIL = '@payment/GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_FAIL',

  GET_COMPLETED_PAYMENT_SET_REQUEST = '@payment/GET_COMPLETED_PAYMENT_SET_REQUEST',
  GET_COMPLETED_PAYMENT_SET_SUCCESS = '@payment/GET_COMPLETED_PAYMENT_SET_SUCCESS',
  GET_COMPLETED_PAYMENT_SET_FAIL = '@payment/GET_COMPLETED_PAYMENT_SET_FAIL',
}

export interface IGetSitePaymentsPayload {
  siteId: string;
  options?: IApiQueryOptions;
}

export interface IGetSiteAcceptancePaymentSetsPayload {
  siteId: string;
  options?: IApiQueryOptions;
}

export interface IGetCompletePaymentSetPayload {
  paymentId: string;
}
